import styled from 'styled-components';
import { VaultButton } from '../../../Shared';

export const VaultPublishButton = styled(VaultButton)`
  height: 42px;
  min-width: 42px;
`;
